import { CheckIcon, ClockIcon } from 'assets/icons';
import Badge from 'components/badge/badge';
import { doneText, dueText, isLate } from 'helper/taskDates';
import { durationLabel } from 'helper/timeLabels';
import useText from 'hooks/useText';
import TaskTypeBadge from '../TaskTypeBadge';
import TaskContactCard from './TaskContactCard';
import TaskDescriptionField from './TaskDescriptionField';
import TaskEmailCard from './TaskEmailCard';

/**
 * The « Détail » tab of a task: its type, its due day (red when late) or the
 * day it was done, who it is about, the e-mail it will send, its description.
 */
const TaskDetailTab = ({ task, onOpenCompany, onSave, canEdit = true }) => {
  const { text } = useText('tasks');
  const now = new Date();
  const late = isLate(task, now);
  const when = task.dueTime
    ? `${dueText(task, now, text)}, ${task.dueTime.slice(0, 5)} · ${durationLabel(task.durationMin ?? 15)}`
    : dueText(task, now, text);
  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-wrap items-center gap-1.5">
        <TaskTypeBadge row={{ ...task, kind: 'task' }} />
        {task.doneAt ? (
          <Badge type="VALID">
            <CheckIcon w={12} h={9} color="currentColor" />
            {doneText(task, text)}
          </Badge>
        ) : (
          <Badge type={late ? 'ALERT' : 'PRIMARY'}>
            <ClockIcon wh={14} color="currentColor" />
            {when}
          </Badge>
        )}
      </div>
      {(task.contactName || task.company) && <TaskContactCard task={task} onOpenCompany={onOpenCompany} />}
      {task.type === 'email' && <TaskEmailCard task={task} onSave={onSave} canEdit={canEdit} />}
      <TaskDescriptionField
        key={task.id}
        initial={task.note ?? ''}
        onSave={(note) => onSave({ note })}
        canEdit={canEdit}
      />
    </div>
  );
};

export default TaskDetailTab;
